/* eslint-disable max-len */

import { projectStyledName } from 'shared/constants'

import { localeAuthType } from '../en-US'

export const auth: localeAuthType = {
  onlyUsersCanUse: 'Solo los usuarios pueden acceder al sitio',
  newPassword: 'Nueva contraseña',
  repeat: 'Confirmar nueva contraseña',
  checking: 'Comprobando',
  sendCode: 'Enviar código',
  restorePassword: 'Recuperación de contraseña',
  password: 'Contraseña',
  authorization: 'Iniciar sesión',
  registration: 'Registro',
  repeatPassword: 'Repetir contraseña',
  firstName: 'Nombre de pila',
  lastName: 'Apellido',
  agentId: 'ID del agente',
  email: 'Correo electrónico',
  needAuth: 'Autorización requerida',
  mobilePhone: 'Teléfono móvil',
  minPhoneLength: 'Debe contener al menos 11 dígitos',
  forgotPassword: 'Olvidó su contraseña?',
  checkEmail: 'Por favor revise su correo electrónico',
  minPassLength: 'Debe contener al menos 8 caracteres',
  passwordsDoNotMatch: 'Las contraseñas no coinciden',
  recoverySuccess: 'Contraseña recuperada con éxito',
  recoveryError: 'Se produjo un error al recuperar la contraseña',
  verifyEmailError: 'Se produjo un error al revisar el correo electrónico',
  signIn: 'Iniciar sesión',
  signUp: 'Regístrate',
  register: 'Registrarse',
  accept: 'Acepto el ',
  username: 'Nombre de usuario',
  signInDescription: 'Ya con nosotros?',
  acceptConditions: 'Términos y Condiciones y la Política de Privacidad',
  twoClicksRegister: 'Hazte socio de nuestro Club en 2 simples clics',
  signInLink: 'Por favor, inicie sesión',
  bonusCode: 'Código de Bono de Promoción',
  doYouHaveBonusCode: '¿Tienes un código de bonificación?',
  minSymbols: 'Número mínimo de caracteres',
  passwordsNotMatched: 'Contraseña no coincidente',
  verifyEmailSuccess: 'Verificación de correo electrónico exitosa. Por favor, inicie sesión',
  forgotPasswordText:
    'Ingrese su dirección de correo electrónico y le enviaré un enlace para restablecer su contraseña de inmediato.',
  resetPasswordEmailSent: 'Se ha enviado un correo electrónico de restablecimiento de contraseña.',
  requiredToAccept: 'Requerido para aceptar',
  required: 'Requerido',
  resendEmailRegistration: 'La carta no ha llegado? Revise la carpeta de correo no deseado o',
  resendEmail: 'Reenviar correo electrónico',
  resendEmailSuccess: 'El correo electrónico se ha enviado correctamente',
  pleaseCheckSpam: 'La carta no ha llegado? Por favor revise su carpeta de spam',
  send: 'Enviar',
  getBonuse: `Quiero obtener bonificaciones y recibir ofertas de ${projectStyledName}`,

  updateYourPassword: 'Actualizar contraseña',
  updatePasswordDescription: 'Debe actualizar su contraseña porque es la primera vez que inicia sesión o porque su contraseña ha expirado',
  passwordChangedSuccessfully: '¡Contraseña cambiada con éxito!',
}
